import { FC } from 'react'
import { motion } from 'framer-motion'
import { FaFacebookF, FaPhoneAlt, FaMapMarkerAlt } from 'react-icons/fa'
import { FaTiktok } from 'react-icons/fa6'

const socialLinks = [
  {
    href: 'https://www.facebook.com/StudioFiguraLarnaca',
    icon: <FaFacebookF />,
    label: 'Facebook',
  },
  {
    href: 'https://www.tiktok.com/@studio_figura149',
    icon: <FaTiktok />,
    label: 'TikTok',
  },
  {
    href: '#contact',
    icon: <FaPhoneAlt />,
    label: 'Phone',
  },
  {
    href: 'https://www.google.com/maps/search/?api=1&query=34.910986258834214,33.62032849547252',
    icon: <FaMapMarkerAlt />,
    label: 'Location',
  },
]

const Footer: FC = () => {
  return (
    <footer className="bg-primary text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col items-center gap-4 mb-10"
        >
          <img
            src="/assets/logo.jpg"
            alt="Studio Figura Logo"
            className="h-48 sm:h-64 w-auto"
          />
          <h2 className="text-xl sm:text-2xl font-bold uppercase tracking-wider">
            Studio Figura Larnaca
          </h2>
        </motion.div>

        {/* Social Links */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex justify-center gap-4 mb-10"
        >
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.href.startsWith('http') ? '_blank' : undefined}
              rel={link.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="w-12 h-12 bg-white/20 hover:bg-white rounded-full flex items-center justify-center transition-all duration-300 hover:text-primary text-lg"
              aria-label={link.label}
            >
              {link.icon}
            </a>
          ))}
        </motion.div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center pt-8 border-t border-white/20"
        >
          <p className="text-sm opacity-80">
            &copy; {new Date().getFullYear()} Studio Figura Larnaca. All Rights Reserved.
          </p>
        </motion.div>
      </div>
    </footer>
  )
}

export default Footer
